import { render, staticRenderFns } from "./QuoteEmailModal.vue?vue&type=template&id=cc2d61fe&scoped=true"
import script from "./QuoteEmailModal.vue?vue&type=script&lang=js"
export * from "./QuoteEmailModal.vue?vue&type=script&lang=js"
import style0 from "./QuoteEmailModal.vue?vue&type=style&index=0&id=cc2d61fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2d61fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc2d61fe')) {
      api.createRecord('cc2d61fe', component.options)
    } else {
      api.reload('cc2d61fe', component.options)
    }
    module.hot.accept("./QuoteEmailModal.vue?vue&type=template&id=cc2d61fe&scoped=true", function () {
      api.rerender('cc2d61fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteEmailModal.vue"
export default component.exports